module.exports = __webpack_public_path__ + "static/media/img190.48134b1d.jpg";